module.exports = __webpack_public_path__ + "static/Q4Answer1_Loud_JasonRosewell-56a186ddc7000c62354946370de0b11a.jpg";